import { z } from "zod";

export const watchlistNameSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Name is required")
    .max(64, "Name must be 64 characters or fewer"),
});

export type WatchlistNameValues = z.infer<typeof watchlistNameSchema>;
